import { Button } from "@mui/material";
import { muiTheme } from "@/styles/theme";
import { useOrganization } from "@/modules/common/context/organizations/get-user-organizations.provider";
interface ApplyOrganisationButtonProps {
  onApply?: () => void;
  setOpenOrganizationsModal: (value: boolean) => void;
}

const ApplyOrganisationButton: React.FC<ApplyOrganisationButtonProps> = ({
  onApply,
  setOpenOrganizationsModal,
}) => {
  const { selectedOrganizations, selectedSingleOrganization } =
    useOrganization();
  return (
    <Button
      variant="contained"
      onClick={() => {
        onApply?.();
        setOpenOrganizationsModal(false);
      }}
      disabled={
        selectedOrganizations.length === 0 && !selectedSingleOrganization
      }
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        borderRadius: 2,
        maxHeight: "40px",
        maxWidth: "110px",
        minWidth: "110px",
        color: muiTheme.colorSchemes.light.palette.background.white,
        background: muiTheme.colorSchemes.light.palette.primary[500],
        ...muiTheme.typography.action_button,
        textTransform: "none",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        "&:hover": {
          color: muiTheme.colorSchemes.light.palette.background.white,
          background: "#034462",
          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        },
      }}
    >
      Apply
    </Button>
  );
};

export default ApplyOrganisationButton;
